import { z } from "zod";
import { ZArticleColoring, ZDrofusArticleProperty } from "@multiconsult-group/multiplacer-core";
import { openapi } from "../../openapi";

export const ZArticleColoringSettings = z.object({
  articleColorings: z.array(ZArticleColoring),
  drofusArticleProperties: z.array(ZDrofusArticleProperty),
});
export type ArticleColoringSettings = z.infer<typeof ZArticleColoringSettings>;

// Add cache invalidation to generated endpoints without redefining their contracts.
export const articleColoringApi = openapi.enhanceEndpoints({
  endpoints: {
    getMultiplacerProjectArticleColoring: {
      providesTags: (_result, _error, { projectNo }) => [
        { type: "projects", id: `articleColoring:${projectNo}` },
      ],
    },
    putMultiplacerProjectArticleColoring: {
      invalidatesTags: (_result, error, { body: { projectNo } }) =>
        error ? [] : [{ type: "projects", id: `articleColoring:${projectNo}` }],
    },
  },
});
